import client from "../client";
import { CheckTimeResponse } from "./check_time";

export default function API(): Promise<CheckTimeResponse[]> {
  return client
    .get(`gameinhouse/checkin/check_in_reward_all_award_status`)
    .then((response) => response.data);
}
